@if (paramsGroup) {
  <div class="date-range">
    <mat-form-field>
      <mat-label>Start date</mat-label>
      <input
        matInput
        [ngModel]="from"
        (ngModelChange)="setValue('from', $event)"
        placeholder="YYYY-MM-DD HH:MM"
        [ngxMatDatetimePicker]="fromPicker"
        [max]="paramsGroup.get('to')?.value" />
      <mat-datepicker-toggle matIconSuffix [for]="$any(fromPicker)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #fromPicker [stepHour]="1" [stepMinute]="1" [defaultTime]="[0, 0]">
        <ngx-mat-datepicker-actions>
          <button mat-stroked-button ngxMatDatepickerApply>
            <span class="material-symbols-outlined">check</span>
          </button>
        </ngx-mat-datepicker-actions>
      </ngx-mat-datetime-picker>
      @if (paramsGroup.get('from')?.hasError('required')) {
        <mat-error>This field is required</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>End date</mat-label>
      <input
        matInput
        [ngModel]="to"
        (ngModelChange)="setValue('to', $event)"
        placeholder="YYYY-MM-DD HH:MM"
        [ngxMatDatetimePicker]="toPicker"
        [min]="paramsGroup.get('from')?.value" />
      <mat-datepicker-toggle matIconSuffix [for]="$any(toPicker)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #toPicker [stepHour]="1" [stepMinute]="1" [defaultTime]="[23, 59, 59]">
        <ngx-mat-datepicker-actions>
          <button mat-stroked-button ngxMatDatepickerApply>
            <span class="material-symbols-outlined">check</span>
          </button>
        </ngx-mat-datepicker-actions>
      </ngx-mat-datetime-picker>
      @if (paramsGroup.get('to')?.hasError('required')) {
        <mat-error>This field is required</mat-error>
      }
    </mat-form-field>
  </div>
}
